import { ContainerStyles } from './Container.styled';

const Container = ({ children }) => (
  <ContainerStyles>{children}</ContainerStyles>
);

export default Container;
